import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, NAV, MEMBERSHIPS } from "../../data/content";
import { MEDIA } from "../../data/media";
import { scrollToId } from "../../lib/motion";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-sage-deep text-cream" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <img src={MEDIA.logo} alt="Ffyona Duncan Therapies" className="h-14 w-auto brightness-0 invert opacity-90" />
            <p className="mt-6 font-serif text-2xl italic text-cream/90 max-w-sm">{CONTACT.tagline}</p>
            <p className="mt-4 text-sage-light/80 text-sm max-w-sm leading-relaxed">
              Warm, professional counselling and clinical supervision in Swindon and online.
            </p>
            <div className="mt-8 flex flex-wrap gap-2">
              {MEMBERSHIPS.map((m) => (
                <span key={m} className="rounded-full border border-sage-light/25 px-3 py-1.5 text-xs text-sage-light">{m}</span>
              ))}
            </div>
          </div>

          <div className="lg:col-span-3">
            <p className="overline text-sage-light mb-5">Explore</p>
            <ul className="space-y-3">
              {NAV.map((n) => (
                <li key={n.id}>
                  <button onClick={() => scrollToId(n.id)} className="text-sage-light/85 hover:text-cream transition-colors text-sm">
                    {n.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="overline text-sage-light mb-5">Contact</p>
            <ul className="space-y-4 text-sm">
              <li>
                <a href={CONTACT.phoneHref} className="flex items-center gap-3 text-sage-light/85 hover:text-cream transition-colors">
                  <Phone size={16} strokeWidth={1.5} /> {CONTACT.phone}
                </a>
              </li>
              <li>
                <a href={`mailto:${CONTACT.email}`} className="flex items-center gap-3 text-sage-light/85 hover:text-cream transition-colors break-all">
                  <Mail size={16} strokeWidth={1.5} /> {CONTACT.email}
                </a>
              </li>
              <li className="flex items-center gap-3 text-sage-light/85">
                <MapPin size={16} strokeWidth={1.5} /> {CONTACT.location}
              </li>
            </ul>
            <button
              onClick={() => scrollToId("contact")}
              className="mt-7 rounded-full bg-cream text-sage-dark px-6 py-3 text-sm font-medium hover:bg-white transition-colors"
              data-testid="footer-book-btn"
            >
              Book free consultation
            </button>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-sage-light/20 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-sage-light/70">© {year} {CONTACT.business}. All rights reserved.</p>
          <ul className="flex gap-6 text-xs text-sage-light/70">
            <li><button className="hover:text-cream transition-colors">Privacy Policy</button></li>
            <li><button className="hover:text-cream transition-colors">Terms</button></li>
            <li><button className="hover:text-cream transition-colors">Cookie Policy</button></li>
          </ul>
        </div>
      </div>
    </footer>
  );
};
